import FigmaEmbed from "../../../../src/components/FigmaEmbed/FigmaEmbed.jsx";
import * as React from 'react';
export default {
  FigmaEmbed,
  React
};